import qs from 'qs'
import util from '@/util/utils'
const WX = {
  preview: function (params) {
    let testMobileType = this.testMobileType();
    let pages = `${params.url}?${qs.stringify(params.obj)}`;
    if(testMobileType == 'ios'){
      window.webkit.messageHandlers.previewWithMiniProgram.postMessage(pages)
    }
    else if(testMobileType == 'android'){
      window.android.previewWithMiniProgram(pages)
    }
  },
  shareApp: function(params = {}) {
    let testMobileType = this.testMobileType();
    let obj = {
      path : `${params.url}?${qs.stringify(params.obj)}`,
      title : params.title,
      image : params.img
    }
    if(testMobileType == 'ios'){
      window.webkit.messageHandlers.circleShareWechat.postMessage(obj)
    }
    else if(testMobileType == 'android'){
      window.android.circleShareWechat(obj.path,obj.title,obj.image)
    }
  },
  savePhoto: function (params) {
    let testMobileType = this.testMobileType();
    if(testMobileType == 'ios'){
      window.webkit.messageHandlers.circleSavePhoto.postMessage(params)
    }
    else if(testMobileType == 'android'){
      window.android.circleSavePhoto(params)
    }
  },
  testMobileType () {
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isAndroid) {
      return 'android'
    } else if (isiOS) {
      return 'ios'
    } else {
      return 'pc'
    }
  },
}

export default {
  install (Vue, options) {
    Vue.prototype.$wxShare = WX
  }
}
